module.exports = __webpack_public_path__ + "static/img/Summer_noproduct.e6784fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/june/Summer_noproduct.png
// module id = LoPa
// module chunks = 4